import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { usePropertyStore } from "../store/usePropertyStore";
import { PropertyEndpoint, RentingEndpoint, UserEndpoint } from "../api";
import {
	Form,
	InputNumber,
	Button,
	Modal,
	Typography,
	message,
	Row,
	Col,
	Card,
	Space,
	Select,
} from "antd";
import { formatRupiah } from "../utils/formatter";

const userAPI = new UserEndpoint();
const rentingAPI = new RentingEndpoint();

const RentingProperty = () => {
	const { id, type } = useParams();
	const navigate = useNavigate();
	const { detailProperti, setDetailProperti } = usePropertyStore();
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(false);
	const [showLoginModal, setShowLoginModal] = useState(false);
	const [selectedRentType, setSelectedRentType] = useState("monthly");

	const [form] = Form.useForm();

	// Cek session user & properti
	useEffect(() => {
		const checkSession = async () => {
			try {
				const sessionUser = await userAPI.getUser();

				setUser(sessionUser);
			} catch {
				setUser(null);
			}
		};

		const propertyEndpoint = new PropertyEndpoint();

		const getOneProperty = async () => {
			try {
				const response = await propertyEndpoint.getPropertyById(
					id,
					type
				);
				setDetailProperti(response);
			} catch (error) {
				console.error("Gagal mengambil properti:", error);
			}
		};

		if (id) getOneProperty();
		checkSession();
	}, [id, type, setDetailProperti]);

	if (!detailProperti) return <p>Loading properti...</p>;
	const property = detailProperti.property || detailProperti;

	const handleSubmit = async (values) => {
		if (!user) {
			setShowLoginModal(true);
			return;
		}

		setLoading(true);
		try {
			const rentRequest = {
				property_id: property.id,
				quantity: values.quantity,
				rent_type: values.rent_type,
			};

			await rentingAPI.createRenting(rentRequest);

			message.success("Request Sewa Berhasil!");
			navigate("/");
		} catch (err) {
			console.error(err);
			message.error(
				err?.response?.data?.message ||
					"Terjadi kesalahan saat menyewa properti"
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Row justify="center" style={{ padding: 24 }}>
			<Col xs={24} sm={20} md={16} lg={12}>
				{/* Tombol Back */}
				<Button
					type="default"
					style={{ marginBottom: 16 }}
					onClick={() => window.history.back()}
				>
					← Kembali
				</Button>

				<Card
					title={
						<Typography.Title level={4}>
							{property.name}
						</Typography.Title>
					}
					bordered={false}
					headStyle={{ fontSize: 20, fontWeight: "bold" }}
					style={{
						borderRadius: 12,
						boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
					}}
				>
					<Space
						direction="vertical"
						size="large"
						style={{ width: "100%" }}
					>
						<Typography.Text type="secondary">
							Lokasi: {property.full_address}, {property.city}
						</Typography.Text>
						<Typography.Text>
							{property.bedrooms} kamar tidur,{" "}
							{property.bathrooms} kamar mandi
						</Typography.Text>
						<Typography.Text>
							Harga sewa: {formatRupiah(property.rent_price)} /{" "}
							{property.rent_type}
						</Typography.Text>
						<Typography.Text>
							Biaya Deposit Awal: {formatRupiah(property.deposit)}
						</Typography.Text>

						<Form
							form={form}
							layout="vertical"
							onFinish={handleSubmit}
						>
							<Form.Item
								label={`Jumlah sewa (${selectedRentType})`}
								name="quantity"
								rules={[
									{
										required: true,
										message: "Jumlah sewa harus diisi",
									},
								]}
								initialValue={property.min_rent || 1}
							>
								<InputNumber
									min={property.min_rent || 1}
									style={{ width: "100%" }}
								/>
							</Form.Item>

							<Form.Item
								label="Tipe Sewa"
								name="rent_type"
								rules={[
									{
										required: true,
										message: "Tipe sewa harus dipilih",
									},
								]}
								initialValue={selectedRentType}
							>
								<Select
									value={selectedRentType}
									onChange={(value) =>
										setSelectedRentType(value)
									}
									style={{ width: "100%" }}
								>
									<Select.Option value="daily">
										Harian
									</Select.Option>
									<Select.Option value="monthly">
										Bulanan
									</Select.Option>
									<Select.Option value="yearly">
										Tahunan
									</Select.Option>
								</Select>
							</Form.Item>

							<Form.Item>
								<Button
									type="primary"
									size="large"
									htmlType="submit"
									block
									loading={loading}
								>
									Sewa Sekarang
								</Button>
							</Form.Item>
						</Form>
					</Space>
				</Card>
			</Col>

			{/* Modal login */}
			<Modal
				title="Login Required"
				open={showLoginModal}
				onCancel={() => setShowLoginModal(false)}
				destroyOnClose
				footer={[
					<Button key="login" type="primary" href="/login">
						Login
					</Button>,
				]}
			>
				<p>Silakan login terlebih dahulu untuk melakukan penyewaan.</p>
			</Modal>
		</Row>
	);
};

export default RentingProperty;
